import { Prop } from "vue-property-decorator";
import Vue from "vue";

/**
 *  Класс для компоненты таблиц
 */
export class CustomTableVue extends Vue {

  /** Данные для заполнения таблицы */
  @Prop() outsideData!: Array<any>;

  /** Заголовки таблицы */
  @Prop() headers!: Array<string>;

  /** Ключи для заполнения таблицы */
  @Prop() keys!: Array<any>;
}
